import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkle } from "@phosphor-icons/react";
import { answers } from "@/data/answers";
import Seo from "@/components/site/Seo";
import { faqJsonLd } from "@/lib/schema";

// Visible, quotable authority "answers" — great for guests and for AI answer engines.
export default function AnswerBlocks() {
  return (
    <section data-testid="answers-section" className="bg-emerald text-sand py-24 md:py-36">
      {/* jsonLd only — does not touch page title/description/canonical */}
      <Seo jsonLd={faqJsonLd(answers)} />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14 md:mb-20">
          <p className="overline text-gold mb-5 flex items-center gap-2">
            <Sparkle size={16} weight="fill" className="text-gold" /> Ask us anything
          </p>
          <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">
            The short answers, straight from the host.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-12 md:gap-y-16">
          {answers.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="border-t border-sand/15 pt-7"
              data-testid={`answer-block-${i}`}
            >
              <h3 className="font-display text-2xl md:text-3xl leading-snug text-sand mb-4">
                {item.q}
              </h3>
              <p className="text-sand/75 font-light leading-relaxed">{item.a}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 md:mt-20">
          <Link
            to="/faq"
            data-testid="answers-faq-link"
            className="group inline-flex items-center gap-2 rounded-full border border-sand/25 px-8 py-4 text-sand font-medium transition-colors duration-300 hover:bg-sunset hover:border-sunset"
          >
            See all guest questions
            <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
